import React from "react";
import { Plan } from "../../../@types";
import { RenderedTable } from "../../../components";
import { useTableConfig, useTranslate } from "../../../helpers";
import { shouldSuppressPlanBenefits } from "../../../helpers";
import { Column } from "react-table";
import { col } from "../../../@types/react-table";

import { BenefitData, convertBenefitData } from "../components/benefitHelper";
import { useSubSectionCaption } from "../components/helper";

export const PartBDrugsTable: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const t = useTranslate();
  const suppressed = shouldSuppressPlanBenefits(plan);

  const cols: Array<Column<col>> = [
    {
      accessor: "label",
    },
    {
      accessor: "value",
    },
    {
      accessor: "limitsApply",
    },
  ];

  // plan_card.package_benefits.BENEFIT_MEDICARE_PART_B
  const partBBenefits = [
    {
      label: t("plan_terms.chemotherapy"),
      service: "chemotherapy",
    },
    {
      label: t("plan_terms.other_part_b_drugs"),
      service: "other_part_b_drugs",
    },
  ] as BenefitData[];

  const data = convertBenefitData(
    plan,
    suppressed,
    t,
    "medicare_part_b",
    partBBenefits,
    t("plan_terms.medicare_part_b_drugs")
  );

  return (
    <RenderedTable
      className="three-column-table"
      tableColumns={useTableConfig(cols)}
      tableData={React.useMemo(() => data, [t])}
      rowHeaders // Indicates the first column should be rendered as `th scope="row"`
      borderless // is a default for Plan Details, TBD if it should be baked in
      stackableBreakpoint="lg" // is a default for Plan Details, TBD if it should be baked in
      caption={useSubSectionCaption(
        "plan_terms.medicare_part_b_drugs",
        "plan_terms.medicare_part_b_drugs.definition"
      )}
    />
  );
};
